module.exports = __webpack_public_path__ + "media/images/public-step2-6ac1ad37.png";